import React from 'react';
import logo from './logo.svg';
import './css/style.css'; 

import { Provider } from 'react-redux';
import store from './store';

import { Routes } from './routes';
import { BrowserRouter } from 'react-router-dom';

const App: React.FC = () => (
  <Provider store={store}>
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  </Provider>
);

export default App;
